export default __webpack_public_path__ + "static/media/1996.5256d9b9.png";